export default "__VITE_ASSET__e8731a6b__"